// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609091434/js/" + chunkId + "." + {"44":"22530a8a","225":"94a29b27","481":"1b4d21df","486":"aa8682ed","770":"5d3ac30b"}[chunkId] + ".0.9231128842779526.chunk.js";
};